// Both link reads, their keys, and the 422-as-null mapping. Auth and onboarding
// gating stay in the delegate and arrive as `isQueryable`.
import { skipToken, useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

import {
  GET_INTEGRATION_LINK_SESSION_INFO,
  GET_LINKED_SESSION_INFO_BY_CASE_ID,
} from '../../contracts/queryKeys';
import { getIntegrationLinkedSessionInfo } from '../api/session-links';

export function useQueryIntegrationLinkSessionInfo({
  sessionId,
  isQueryable,
}: {
  sessionId: string;
  isQueryable: boolean;
}) {
  return useQuery({
    queryKey: [GET_INTEGRATION_LINK_SESSION_INFO, { sessionId }],
    retry: false,
    queryFn: isQueryable
      ? async () => {
          try {
            const { data } = await getIntegrationLinkedSessionInfo({ sessionId });
            return data;
          } catch (error) {
            // 422 means no integration link exists for this session. Cache null
            // so the query does not refire on every remount or window focus.
            if (isAxiosError(error) && error.response?.status === 422) {
              return null;
            }
            throw error;
          }
        }
      : skipToken,
  });
}

export function useQueryIntegrationLinkSessionInfoByCaseId({
  caseId,
  isQueryable,
}: {
  caseId?: string;
  isQueryable: boolean;
}) {
  return useQuery({
    queryKey: [GET_LINKED_SESSION_INFO_BY_CASE_ID, { caseId }],
    retry: false,
    queryFn: isQueryable
      ? async () => {
          const { data } = await getIntegrationLinkedSessionInfo({
            provider_unique_identifier: caseId,
          });
          return data;
        }
      : skipToken,
  });
}
